function Bottombar() {
  return (
    <div className="bottombar">
        <div className="bottombar-btn">
            <p className="bg-circle-white">A</p>
            <p className="text-btn">See Details</p>
        </div>
        <div className="bottombar-btn">
            <p className="bg-circle-white">X</p>
            <p className="text-btn">Habitat</p>
        </div>
        <div className="bottombar-btn">
            <p className="bg-circle-white">Y</p>
            <p className="text-btn">Sort</p>
        </div>
        <div className="bottombar-btn">
            <p className="bg-circle-white">+</p>
            <p className="text-btn">See Evaluation</p>
        </div>
        <div className="bottombar-btn">
            <p className="bg-circle-white">B</p>
            <p className="text-btn">Back</p>
        </div>

    </div>
  )
}

export default Bottombar